package com.kaihuoy.components.common

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.components.common.*


fun isMobileScreen() = window.innerWidth <= 600
fun screenContentPadding(): CSSSizeValue<*> = if (isMobileScreen()) 16.px else 32.px

@Composable
fun PageLayout(
    onLogout: () -> Unit,
    greeting: String,
    content: @Composable () -> Unit
) {
    var screenWidth by remember { mutableStateOf(window.innerWidth) }
    DisposableEffect(Unit) {
        val callback = { _: dynamic -> screenWidth = window.innerWidth }
        window.addEventListener("resize", callback)
        onDispose { window.removeEventListener("resize", callback) }
    }
    val isMobile = screenWidth <= 600
    val hPad = if (isMobile) 12.px else 32.px

    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            minHeight(100.vh)
            backgroundColor(KaihuTheme.Background)
            width(100.percent)
            property("max-width", "100vw")
            property("overflow-x", "hidden")
            padding(20.px, hPad, 0.px, hPad)
            boxSizing("border-box")
        }
    }) {
        Div(attrs = {
            style {
                property("box-sizing", "border-box")
                width(100.percent)
                minHeight(if (isMobile) 70.px else 180.px)
            }
        }) {
            TopBar(greeting = greeting, onLogout = onLogout)
        }

        content()
    }
}